export const environment = {
  production: true,
  apiAddress: 'https://api.imgoingcalendar.com/api/',
  serverDomain: 'https://api.imgoingcalendar.com/',
  imageServeUrl: 'https://api.imgoingcalendar.com/imgs/',
  socketIOAddress: 'https://api.imgoingcalendar.com',
  frontendDomain: 'https://next.imgoingcalendar.com/',
};
